var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87733 14V2.92871H8.08267C9.61867 2.92871 10.28 4.05588 10.28 5.90944V8.78998H12.1573V5.85935C12.1573 4.53179 11.9653 3.65511 11.624 2.95376C11.0053 1.6763 9.91733 1 8.44533 1H1V14H2.87733ZM9.10667 14C14.2693 14 17 10.7938 17 5.35838V1H15.2293V5.20809C15.2293 9.69172 13.2453 12.1214 9.21333 12.1214H7.464V5.53372H5.69333V14H9.10667Z",
    fill: "#5D5D67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls);
export default __webpack_public_path__ + "static/media/ILS.d0ad2db1361916bb021f06ee80ca0a76.svg";
export { ForwardRef as ReactComponent };